import session from "./session";
import { queryBuilder } from "@/helpers/api";

export default {
  getStaticData(search) {
    const ALLOWED_KEYS = ["available", "field", "field__in", "kind", "kind__in", "object_kind", "object_kind__in"];
    const query = queryBuilder(ALLOWED_KEYS, search);
    return session.get(`/static-data/options/?${query}`);
  }
}